<template>
  <div class="w-full overflow-x-auto md:overflow-auto">
    <table class="w-full">
      <!-- Thead header  -->
      <tr>
        <th class="md:w-4/12 p-6">
          <h5 class="font-bold ml-5">What is covered</h5>
        </th>
        <th class="md:w-4/12 p-6 text-center">
          <h5 class="font-bold">No additional protection</h5>
        </th>
        <th class="md:w-4/12 p-6 text-center">
          <h5 class="font-bold">Full Protection</h5>
        </th>
      </tr>
      <!-- first row  -->
      <tr>
        <td @click="toggleCollapsible(1)">
          <h5 class="m-5 cursor-pointer inline-block text-footerColor">
            Insurance
          </h5>
          <div v-if="activeCollapsible === 1" class="m-5">
            <p>
              Your car comes with standard damage cover (CDW) with an excess of
              RM 3,000 and Theft Protection (TP) with an excess of RM 3,000. If
              the bodywork is damaged or the car is stolen, the car hire company
              could charge you up to the excess amount – but Rentalcover.com
              will refund you.
            </p>
          </div>
        </td>
        <!-- x  -->
        <td class="text-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8 mt-4" style="fill: #484848">
            <path
              d="M13.31 12l6.89-6.89a.93.93 0 1 0-1.31-1.31L12 10.69 5.11 3.8A.93.93 0 0 0 3.8 5.11L10.69 12 3.8 18.89a.93.93 0 0 0 1.31 1.31L12 13.31l6.89 6.89a.93.93 0 1 0 1.31-1.31z">
            </path>
          </svg>
        </td>
        <!-- ✔  -->
        <td class="text-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8 mt-4" style="fill: green">
            <path
              d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.992 5.376 18.624.008 12 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 0 1-1.43.188l-4.888-3.908a1 1 0 0 1 1.25-1.562l4.076 3.261 6.227-8.451a1 1 0 1 1 1.61 1.183z">
            </path>
          </svg>
        </td>
      </tr>
      <!-- Second row  -->
      <tr>
        <td @click="toggleCollapsible(2)">
          <h5 class="m-5 cursor-pointer inline-block text-footerColor">
            Windows, mirrors, wheels & tyres
          </h5>
          <div v-if="activeCollapsible === 2" class="m-5">
            <p>
              Protection products often have exclusions, but Full Protection
              covers every exterior and mechanical part of your car, from wheels
              and windows to engine, roof & undercarriage.
            </p>
          </div>
        </td>
        <!-- x  -->
        <td class="text-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8 mt-4" style="fill: #484848">
            <path
              d="M13.31 12l6.89-6.89a.93.93 0 1 0-1.31-1.31L12 10.69 5.11 3.8A.93.93 0 0 0 3.8 5.11L10.69 12 3.8 18.89a.93.93 0 0 0 1.31 1.31L12 13.31l6.89 6.89a.93.93 0 1 0 1.31-1.31z">
            </path>
          </svg>
        </td>
        <!-- ✔  -->
        <td class="text-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8 mt-4" style="fill: green">
            <path
              d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.992 5.376 18.624.008 12 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 0 1-1.43.188l-4.888-3.908a1 1 0 0 1 1.25-1.562l4.076 3.261 6.227-8.451a1 1 0 1 1 1.61 1.183z">
            </path>
          </svg>
        </td>
      </tr>
      <!-- Third row  -->
      <tr>
        <td @click="toggleCollapsible(3)">
          <h5 class="m-5 cursor-pointer inline-block text-footerColor">
            Administration and breakdown charges
          </h5>
          <div v-if="activeCollapsible === 3" class="m-5">
            <p>
              If you break down, lose your key(s) or lock yourself out,
              Rentalcover.com will refund any call-out charges, towing fees and
              key replacement costs.
            </p>
          </div>
        </td>
        <!-- x  -->
        <td class="text-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8 mt-4" style="fill: #484848">
            <path
              d="M13.31 12l6.89-6.89a.93.93 0 1 0-1.31-1.31L12 10.69 5.11 3.8A.93.93 0 0 0 3.8 5.11L10.69 12 3.8 18.89a.93.93 0 0 0 1.31 1.31L12 13.31l6.89 6.89a.93.93 0 1 0 1.31-1.31z">
            </path>
          </svg>
        </td>
        <!-- ✔  -->
        <td class="text-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8 mt-4" style="fill: green">
            <path
              d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.992 5.376 18.624.008 12 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 0 1-1.43.188l-4.888-3.908a1 1 0 0 1 1.25-1.562l4.076 3.261 6.227-8.451a1 1 0 1 1 1.61 1.183z">
            </path>
          </svg>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeCollapsible: null,
    };
  },
  methods: {
    toggleCollapsible(index) {
      this.activeCollapsible = this.activeCollapsible === index ? null : index;
    },
  },
};
</script>

<style scoped>
table,
tr {
  border: 1px solid gray;
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  box-sizing: border-box;
}
</style>
